// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__uiQHU","modalFooterButton":"ModalNotes_modalFooterButton__3dCML"};